import cSvg from '#themes/default/default/components/svg/svg.js';

import template from './breadcrumbItem.html' with { type: 'html' };

export default {
	name: 'CBreadcrumbItem',
	components: {
		cSvg
	},
	props: {
		iconNumber: {
			type: Number,
			default: null
		},
		isLast: {
			type: Boolean,
			default: false
		},
		name: {
			type: String,
			required: true
		},
		page: {
			type: Object,
			default: () => null
		},
		stepNumber: {
			type: Number,
			required: true
		}
	},
	computed: {
		isActive() {
			return this.stepNumber === this.page.number;
		},
		stepIcon() {
			const activeModifier = this.isActive ? '-active' : '';
			return `#breadcrumb-number${this.iconNumber}${activeModifier}`;
		}
	},
	template
};
